import { IDragRackItemData3 } from "@mobx/store/locations/types";

export interface Point {
  readonly x: number;
  readonly y: number;
}

export const RACK_ITEM_DRAG_END_EVENT = "rack-item-drag-end";

export interface RackItemDragEndDetail {
  readonly item: IDragRackItemData3;
  readonly point?: Point;
}

export const isPointOutsideElement = (
  element: HTMLElement | null,
  point?: Point
) => {
  if (!element || !point) return false;

  const rect = element.getBoundingClientRect();
  return (
    point.x < rect.left ||
    point.x > rect.right ||
    point.y < rect.top ||
    point.y > rect.bottom
  );
};

export const isPointOutsideElementTree = (
  element: HTMLElement | null,
  point?: Point
) => {
  if (!element || !point) return false;
  if (!document.elementFromPoint) return false;

  const target = document.elementFromPoint(point.x, point.y);
  return target instanceof HTMLElement && !element.contains(target);
};
